var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_1842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 12C24.6667 5.37258 19.2942 0 12.6667 0C6.03933 0 0.666748 5.37258 0.666748 12C0.666748 17.9895 5.05495 22.954 10.7917 23.8542V15.4688H7.74487V12H10.7917V9.35625C10.7917 6.34875 12.5833 4.6875 15.3243 4.6875C16.6368 4.6875 18.0105 4.92188 18.0105 4.92188V7.875H16.4974C15.0067 7.875 14.5417 8.80008 14.5417 9.75V12H17.8699L17.3378 15.4688H14.5417V23.8542C20.2785 22.954 24.6667 17.9895 24.6667 12Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3378 15.4688L17.8699 12H14.5417V9.75C14.5417 8.80102 15.0067 7.875 16.4974 7.875H18.0105V4.92188C18.0105 4.92188 16.6373 4.6875 15.3243 4.6875C12.5833 4.6875 10.7917 6.34875 10.7917 9.35625V12H7.74487V15.4688H10.7917V23.8542C12.0342 24.0486 13.2993 24.0486 14.5417 23.8542V15.4688H17.3378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.038c74cb605db76a9cfeb32e9bbebf5d.svg";
export { ForwardRef as ReactComponent };